<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="primary" class="mb-2" />

    <div v-if="!cargando && items.length === 0" class="text-center py-6 grey--text">No se encontraron solicitudes.</div>

    <v-expansion-panels v-else accordion multiple v-model="panelsAbiertos">
      <v-expansion-panel v-for="solicitud in items" :key="solicitud.id">
        <v-expansion-panel-header>
          <div class="d-flex flex-wrap align-center" style="gap: 8px">
            <strong class="mr-2">#{{ solicitud.numero }}</strong>
            <v-spacer />
            <span class="caption font-weight-bold mr-4">
              Total: Bs.
              {{
                formatearImporte(solicitud.detalle_solicitud.reduce((acc, detalle) => acc + Number(detalle.importe), 0))
              }}
            </span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-simple-table dense class="tabla-detalle-solicitud">
            <thead>
              <tr>
                <th class="col-check"></th>
                <th class="col-id">ID</th>
                <th class="col-clasificador">Clasificador</th>
                <th class="col-sede-origen">Sede Origen</th>
                <th class="col-sede-destino">Sede Destino</th>
                <th class="col-cuenta-destino">Cuenta Destino</th>
                <th class="text-right col-importe">Importe</th>
                <th class="col-estado">Estado</th>
                <th class="col-comprobante">Comprobante</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="detalle in solicitud.detalle_solicitud"
                :key="detalle.id"
                :class="{ 'grey lighten-4': estaDeshabilitado(detalle) && !detallesCarritoIds.has(detalle.id) }">
                <td>
                  <v-tooltip bottom :disabled="!estaDeshabilitadoPorCuenta(detalle)">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-checkbox
                          v-if="!estaDeshabilitado(detalle)"
                          :input-value="detallesCarritoIds.has(detalle.id)"
                          :disabled="estaDeshabilitado(detalle)"
                          dense
                          hide-details
                          class="ma-0 pa-0"
                          @change="$emit('toggleDetalle', detalle)" />
                      </span>
                    </template>
                    <span>Cuenta destino diferente: {{ detalle.cuenta_destino }}</span>
                  </v-tooltip>
                </td>
                <td class="caption">{{ detalle.id }}</td>
                <td class="caption">
                  <span v-if="detalle.clasificador">
                    {{ detalle.clasificador.codigo }} - {{ detalle.clasificador.nombre }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td class="caption">{{ detalle.sede_origen || '-' }}</td>
                <td class="caption">{{ detalle.sede_destino || '-' }}</td>
                <td class="caption">{{ detalle.cuenta_destino || '-' }}</td>
                <td class="caption text-right">{{ formatearImporte(detalle.importe) }}</td>
                <td>
                  <v-chip x-small dark :color="obtenerColorEstado(detalle.estado)">
                    {{ detalle.estado }}
                  </v-chip>
                </td>
                <td class="caption">
                  <span v-if="detalle.comprobante_reversion_id" class="success--text d-flex align-center">
                    <v-icon x-small color="success">mdi-check-circle</v-icon>
                    <span class="mx-1">#{{ detalle.comprobante_reversion_id }}</span>
                    <v-btn
                      icon
                      x-small
                      @click="$emit('verComprobante', { comprobanteReversionId: detalle.comprobante_reversion_id, detalleId: detalle.id })">
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </span>
                  <span v-else class="grey--text">Sin comprobante</span>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="text-right font-weight-bold caption">Total:</td>
                <td class="text-right font-weight-bold caption">{{ totalImporte(solicitud) }}</td>
                <td colspan="2"></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { obtenerColorEstadoDetalleSolicitud } from '../utils';

export default {
  name: 'ListadoSolicitudesParaComprobanteReversion',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    cargando: {
      type: Boolean,
      default: false,
    },
    detallesCarritoIds: {
      type: Set,
      default: () => new Set(),
    },
    cuentaDestinoCarrito: {
      type: String,
      default: null,
    },
    expandirTodo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panelsAbiertos: [],
    };
  },
  watch: {
    expandirTodo(value) {
      this.panelsAbiertos = value ? this.items.map((_, i) => i) : [];
    },
    items(value) {
      this.panelsAbiertos = this.expandirTodo ? value.map((_, i) => i) : [];
    },
  },
  methods: {
    obtenerColorEstado(estado) {
      return obtenerColorEstadoDetalleSolicitud(estado);
    },
    formatearImporte(valor) {
      return Number(valor || 0).toFixed(2);
    },
    totalImporte(solicitud) {
      return solicitud.detalle_solicitud.reduce((s, d) => s + Number(d.importe || 0), 0).toFixed(2);
    },
    estaDeshabilitadoPorCuenta(detalle) {
      return (
        !!this.cuentaDestinoCarrito &&
        detalle.cuenta_destino !== this.cuentaDestinoCarrito &&
        !this.detallesCarritoIds.has(detalle.id)
      );
    },
    estaDeshabilitado(detalle) {
      return !!detalle.comprobante_reversion_id || this.estaDeshabilitadoPorCuenta(detalle);
    },
  },
};
</script>

<style scoped>
.tabla-detalle-solicitud ::v-deep table {
  table-layout: fixed;
  width: 100%;
  min-width: 1440px;
}

.tabla-detalle-solicitud ::v-deep td {
  white-space: normal;
  word-break: break-word;
}

.tabla-detalle-solicitud ::v-deep .col-check {
  width: 58px;
}
.tabla-detalle-solicitud ::v-deep .col-id {
  width: 101px;
}
.tabla-detalle-solicitud ::v-deep .col-clasificador {
  width: 331px;
}
.tabla-detalle-solicitud ::v-deep .col-sede-origen {
  width: 158px;
}
.tabla-detalle-solicitud ::v-deep .col-sede-destino {
  width: 158px;
}
.tabla-detalle-solicitud ::v-deep .col-cuenta-destino {
  width: 144px;
}
.tabla-detalle-solicitud ::v-deep .col-importe {
  width: 130px;
}
.tabla-detalle-solicitud ::v-deep .col-estado {
  width: 115px;
}
.tabla-detalle-solicitud ::v-deep .col-comprobante {
  width: 245px;
}

@media (min-width: 1263px) {
  .tabla-detalle-solicitud ::v-deep table {
    min-width: 0;
  }
  .tabla-detalle-solicitud ::v-deep .col-check {
    width: 4%;
  }
  .tabla-detalle-solicitud ::v-deep .col-id {
    width: 7%;
  }
  .tabla-detalle-solicitud ::v-deep .col-clasificador {
    width: 23%;
  }
  .tabla-detalle-solicitud ::v-deep .col-sede-origen {
    width: 11%;
  }
  .tabla-detalle-solicitud ::v-deep .col-sede-destino {
    width: 11%;
  }
  .tabla-detalle-solicitud ::v-deep .col-cuenta-destino {
    width: 10%;
  }
  .tabla-detalle-solicitud ::v-deep .col-importe {
    width: 9%;
  }
  .tabla-detalle-solicitud ::v-deep .col-estado {
    width: 8%;
  }
  .tabla-detalle-solicitud ::v-deep .col-comprobante {
    width: 17%;
  }
}
</style>
